import { z } from "zod";
import { Principal, PrincipalKind } from "./identity.js";
const Id = z.number().int().positive();
export const GroupKey = z
    .string()
    .min(1)
    .max(60)
    .regex(/^[a-z][a-z0-9_-]*$/, "group key must be lower-case letters, digits, underscores or hyphens");
export const Group = z.object({
    id: Id,
    key: GroupKey,
    name: z.string(),
    description: z.string(),
    members: z.array(Principal),
    createdAt: z.coerce.date(),
});
export const CreateGroupInput = z.object({
    key: GroupKey,
    name: z.string().min(1).max(200),
    description: z.string().max(2000).default(""),
    members: z.array(Principal).default([]),
});
export const UpdateGroupInput = z.object({ name: z.string().min(1).max(200).optional(), description: z.string().max(2000).optional() }).strict();
export const GroupMembersInput = z.object({ members: z.array(Principal).min(1) });
export const Permission = z.enum(["read", "comment", "update", "create_child", "delete", "manage_acl"]);
export const ALL_PERMISSIONS = ["read", "comment", "update", "create_child", "delete", "manage_acl"];
export const ScopeRef = z.object({ kind: z.enum(["container", "object"]), id: Id });
export const AclEntry = z.object({
    id: Id,
    scope: ScopeRef,
    principal: Principal,
    permissions: z.array(Permission),
    createdAt: z.coerce.date(),
});
/** Set (replace) one principal's permissions on a scope. */
export const GrantInput = z.object({ principal: Principal, permissions: z.array(Permission).min(1) });
export const RevokeInput = z.object({ principal: Principal });
export const RestrictInput = z.object({
    /** principals whose current effective access is copied onto the node; defaults to the caller */
    keep: z.array(Principal).default([]),
});
export const Explanation = z.object({
    object: z.object({ id: Id, containerId: Id, aclRootId: Id.nullable(), restricted: z.boolean() }),
    principal: Principal,
    /** every principal considered: the subject plus its transitive groups */
    principals: z.array(Principal),
    isProjectAdmin: z.boolean(),
    roleCeiling: z.array(Permission),
    permissions: z.array(Permission),
    grants: z.array(z.object({
        entryId: Id,
        scope: ScopeRef,
        via: Principal,
        permissions: z.array(Permission),
        /** false when the grant exists but inheritance is cut by a restricted node */
        applies: z.boolean(),
    })),
});
export { PrincipalKind };
//# sourceMappingURL=acl.js.map